export default () => ({
    allows: undefined,
    portfolioId: undefined,
    disable: undefined,
    role: undefined,
    userProject: undefined,
});
